import React from "react";

const TEXTS = {
  optional: {
    title: "Wyniki pośrednie są opcjonalne.",
    body: "Wpisz je, jeśli chcesz dostać punkty cząstkowe. Poprawny wynik końcowy daje pełne punkty.",
  },
  methodOptional: {
    title: "Zapis metody jest opcjonalny.",
    body: "Wpisz równanie lub układ równań, aby móc zdobyć punkt cząstkowy. Poprawny wynik końcowy daje pełne punkty.",
  },
  independent: {
    title: "Uzupełnij wszystkie wymagane pola.",
    body: "Każda poprawna odpowiedź jest oceniana osobno, zgodnie z punktacją zadania.",
  },
  proof: {
    title: "Wpisz kluczowe kroki rozumowania.",
    body: "Punkty są przyznawane za poprawne etapy dowodu lub uzasadnienia.",
  },
};

export default function OpenTaskScoringHint({ variant = "optional", children }) {
  const text = TEXTS[variant] || TEXTS.optional;

  return (
    <div
      style={{
        fontSize: 12.5,
        opacity: 0.78,
        lineHeight: 1.45,
        borderLeft: "3px solid var(--color-accent)",
        paddingLeft: 8,
      }}
    >
      <strong>{text.title}</strong>{" "}
      {children || text.body}
    </div>
  );
}
